import { useContext, useMemo } from 'react';
import { MailhouseAxiosContext } from '@/app/components/MailhouseAxios';
import { mailhouseApi } from '@/services/mailhouseApi';

export const useMailhouseApi = () => {
    const axios = useContext(MailhouseAxiosContext);

    if (!axios) {
        throw new Error('useMailhouseApi must be used within a MailhouseAxios provider');
    }

    return useMemo(() => mailhouseApi(axios), [axios]);
};

export function extractErrorMessage(err: unknown): string {
    const e = err as { formattedError?: string; message?: string } | undefined;
    return e?.formattedError || e?.message || 'Something went wrong.';
}

export default useMailhouseApi;
